// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************
* GLOBAL COLOR TOKENS * 
***********************/
.SimpleModalContent-module__topBar--fWu8M {
  height: 0.5rem;
  background-color: #2463eb;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  margin: -1.5rem -1.5rem 0rem -1.5rem;
}
.SimpleModalContent-module__topBar--fWu8M.SimpleModalContent-module__errorVariant--bnrlc {
  background-color: #dc2625;
}

.SimpleModalContent-module__modalContent--DYmO7 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
}

.SimpleModalContent-module__modalTextContainer--lCR2E {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.SimpleModalContent-module__modalText--X4IrF {
  padding-bottom: 0.5rem;
}

.SimpleModalContent-module__modalTitle--oOGvA {
  color: #0f172a;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-family: var(--font-family);
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  overflow-wrap: break-word;
}

.SimpleModalContent-module__modalBody--xgkMz {
  color: #0f172a;
  font-family: var(--font-family);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

.SimpleModalContent-module__modalButtonContainer--bsMwT {
  display: flex;
  align-items: center;
  gap: 1rem;
  align-self: stretch;
}

button.SimpleModalContent-module__modalButton--Pceib {
  display: flex;
  padding: 0.5rem 1.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  flex: 1 0 0;
  border-radius: 0.25rem;
  /* Body/Regular 16px */
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

button.SimpleModalContent-module__modalButton--Pceib:disabled {
  background-color: #cbd5e1;
}

.SimpleModalContent-module__buttonCancel--NOFI0 {
  background-color: transparent;
  color: #334155;
}
.SimpleModalContent-module__buttonCancel--NOFI0:hover {
  background-color: #f1f5f9;
}

button.SimpleModalContent-module__buttonConfirm--RLygp {
  background-color: #2463eb;
  color: #f8fafc;
}
button.SimpleModalContent-module__buttonConfirm--RLygp.SimpleModalContent-module__errorVariant--bnrlc {
  background-color: #991b1b;
}
button.SimpleModalContent-module__buttonConfirm--RLygp:focus {
  border-color: #bfdbfe;
}

.SimpleModalContent-module__buttonConfirm--RLygp:hover:not(:disabled) {
  background-color: #60a5fa;
}

.SimpleModalContent-module__className--WmBf2 {
  color: #1d40ae;
  font-family: monospace;
  word-wrap: anywhere;
}`, "",{"version":3,"sources":["webpack://./src/_variables.scss","webpack://./src/components/Modals/SimpleModalContent.module.scss"],"names":[],"mappings":"AAAA;;uBAAA;ACEA;EACC,cAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,oCAAA;AAED;AAAC;EACC,yBAAA;AAEF;;AACA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAED;;AAAA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAGD;;AADA;EACC,sBAAA;AAID;;AADA;EACC,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAID;;AADA;EACC,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAID;;AADA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAID;;AADA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EAEA,sBAAA;EAEA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAED;;AACA;EACC,yBAAA;AAED;;AACA;EACC,6BAAA;EACA,cAAA;AAED;AADC;EACC,yBAAA;AAGF;;AACA;EACC,yBAAA;EACA,cAAA;AAED;AADC;EACC,yBAAA;AAGF;AADC;EACC,qBAAA;AAGF;;AACA;EACC,yBAAA;AAED;;AACA;EACC,cAAA;EACA,sBAAA;EACA,mBAAA;AAED","sourcesContent":["/***********************\n* GLOBAL COLOR TOKENS * \n***********************/\n$--neutral-00: #ffffff;\n$--neutral-50: #fafafa;\n$--neutral-100: #f4f4f5;\n$--neutral-200: #e4e4e7;\n$--neutral-300: #d4d4d8;\n$--neutral-400: #a1a1aa;\n$--neutral-500: #71717a;\n$--neutral-600: #52525b;\n$--neutral-700: #3f3f46;\n$--neutral-800: #27272a;\n$--neutral-900: #18181b;\n\n$--neutral-variant-00: #f8fafc;\n$--neutral-variant-50: #f1f5f9;\n$--neutral-variant-100: #e2e8f0;\n$--neutral-variant-200: #cbd5e1;\n$--neutral-variant-300: #b9c3d1;\n$--neutral-variant-400: #94a2b8;\n$--neutral-variant-500: #64738b;\n$--neutral-variant-600: #475569;\n$--neutral-variant-700: #334155;\n$--neutral-variant-800: #1e293b;\n$--neutral-variant-900: #0f172a;\n\n$--primary-00: #f7fbff;\n$--primary-50: #eff6ff;\n$--primary-100: #dbe9fe;\n$--primary-200: #bfdbfe;\n$--primary-300: #92c5fd;\n$--primary-400: #60a5fa;\n$--primary-500: #3c82f6;\n$--primary-600: #2463eb;\n$--primary-700: #1c4ed8;\n$--primary-800: #1d40ae;\n$--primary-900: #1f3a8a;\n\n$--secondary-00: #fcfffd;\n$--secondary-50: #ecfef6;\n$--secondary-100: #d1fae5;\n$--secondary-200: #a8f3d0;\n$--secondary-300: #6ee7b7;\n$--secondary-400: #34d399;\n$--secondary-500: #12b981;\n$--secondary-600: #079669;\n$--secondary-700: #047857;\n$--secondary-800: #076046;\n$--secondary-900: #064e3b;\n\n$--error-00: #fffdfd;\n$--error-50: #fef2f2;\n$--error-100: #fee2e1;\n$--error-200: #fecaca;\n$--error-300: #fda5a5;\n$--error-400: #f87171;\n$--error-500: #ef4444;\n$--error-600: #dc2625;\n$--error-700: #b91c1b;\n$--error-800: #991b1b;\n$--error-900: #7f1c1d;\n","@import \"../../variables\";\n\n.topBar {\n\theight: 0.5rem;\n\tbackground-color: #{$--primary-600};\n\tborder-top-left-radius: 0.5rem;\n\tborder-top-right-radius: 0.5rem;\n\tmargin: -1.5rem -1.5rem 0rem -1.5rem;\n\n\t&.errorVariant {\n\t\tbackground-color: #{$--error-600};\n\t}\n}\n.modalContent {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tgap: 2rem;\n}\n.modalTextContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.5rem;\n}\n.modalText {\n\tpadding-bottom: 0.5rem;\n}\n\n.modalTitle {\n\tcolor: #{$--neutral-variant-900};\n\tmargin-top: 1.5rem;\n\tmargin-bottom: 0.5rem;\n\tfont-family: var(--font-family);\n\tfont-size: 1.25rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 130%;\n\toverflow-wrap: break-word;\n}\n\n.modalBody {\n\tcolor: #{$--neutral-variant-900};\n\tfont-family: var(--font-family);\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 150%; /* 24px */\n}\n\n.modalButtonContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 1rem;\n\talign-self: stretch;\n}\n\nbutton.modalButton {\n\tdisplay: flex;\n\tpadding: 0.5rem 1.5rem;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 0.625rem;\n\tflex: 1 0 0;\n\n\tborder-radius: 0.25rem;\n\n\t/* Body/Regular 16px */\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 150%; /* 24px */\n}\n\nbutton.modalButton:disabled {\n\tbackground-color: #{$--neutral-variant-200};\n}\n\n.buttonCancel {\n\tbackground-color: transparent;\n\tcolor: #{$--neutral-variant-700};\n\t&:hover {\n\t\tbackground-color: #{$--neutral-variant-50};\n\t}\n}\n\nbutton.buttonConfirm {\n\tbackground-color: #{$--primary-600};\n\tcolor: #{$--neutral-variant-00};\n\t&.errorVariant {\n\t\tbackground-color: #{$--error-800};\n\t}\n\t&:focus {\n\t\tborder-color: #{$--primary-200};\n\t}\n}\n\n.buttonConfirm:hover:not(:disabled) {\n\tbackground-color: #{$--primary-400};\n}\n\n.className {\n\tcolor: #{$--primary-800};\n\tfont-family: monospace;\n\tword-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topBar": `SimpleModalContent-module__topBar--fWu8M`,
	"errorVariant": `SimpleModalContent-module__errorVariant--bnrlc`,
	"modalContent": `SimpleModalContent-module__modalContent--DYmO7`,
	"modalTextContainer": `SimpleModalContent-module__modalTextContainer--lCR2E`,
	"modalText": `SimpleModalContent-module__modalText--X4IrF`,
	"modalTitle": `SimpleModalContent-module__modalTitle--oOGvA`,
	"modalBody": `SimpleModalContent-module__modalBody--xgkMz`,
	"modalButtonContainer": `SimpleModalContent-module__modalButtonContainer--bsMwT`,
	"modalButton": `SimpleModalContent-module__modalButton--Pceib`,
	"buttonCancel": `SimpleModalContent-module__buttonCancel--NOFI0`,
	"buttonConfirm": `SimpleModalContent-module__buttonConfirm--RLygp`,
	"className": `SimpleModalContent-module__className--WmBf2`
};
export default ___CSS_LOADER_EXPORT___;
